import { render } from "./StepDocumenti.vue?vue&type=template&id=ce2bee38&scoped=true"
import script from "./StepDocumenti.vue?vue&type=script&lang=js"
export * from "./StepDocumenti.vue?vue&type=script&lang=js"

import "./StepDocumenti.vue?vue&type=style&index=0&id=ce2bee38&lang=css"
import "./StepDocumenti.vue?vue&type=style&index=1&id=ce2bee38&scoped=true&lang=css"
import "./StepDocumenti.vue?vue&type=style&index=2&id=ce2bee38&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce2bee38"]])

export default __exports__